import { render } from "./Main.vue?vue&type=template&id=47510813"
const script = {}
script.render = render

export default script